import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  TextField,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import { createPortal } from "react-dom";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import leafLeft from "../../Asset/icon/leafLeft.svg";
import leafRight from "../../Asset/icon/leafRight.svg";
import { useDispatch } from "react-redux";
import { sendEmailForgetPasswordAction } from "../../redux/Auth/AuthSlice";
import "../../Asset/scss/takemyyacht.scss";

const ForgotPasswordModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);

  useEffect(() => {
    if (open) {
      setStatus("");
      setEmail("");
      setOpenSnackbar(false);
      setOpenErrorSnackbar(false);
    }
  }, [open]);

  useEffect(() => {
    if (status === "success") {
      setOpenSnackbar(true);
    } else if (status === "error") {
      setOpenErrorSnackbar(true);
    }
  }, [status]);

  const handleSubmit = async () => {
    let mailformat =
      /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    if (email && mailformat.test(email)) {
      const data = {
        email,
        url: `${window.location.protocol}//${window.location.host}`,
      };

      const result = await dispatch(sendEmailForgetPasswordAction(data));

      if (result.status === "success") {
        setStatus("success");
        setEmail("");
        setTimeout(onClose, 3000);
      } else {
        setStatus("error");
      }
    } else {
      setStatus("error");
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="forgot-password-modal-title"
        aria-describedby="forgot-password-modal-description"
      >
        <div className="modalContentFP">
          <IconButton className="iconButtonClose" onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <div className="d-flex align-items-center centerAlign w-full">
            <img
              className="img-fluid"
              draggable={false}
              src={leafLeft}
              alt="leftImage"
            />
            <h4 className="textColorPrimary m-2">{t("Forgot Password")}</h4>
            <img
              className="img-fluid"
              draggable={false}
              src={leafRight}
              alt="rightImage"
            />
          </div>

          <TextField
            label={t("Enter your email")}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (status === "error") {
                setStatus("");
              }
            }}
            fullWidth
            variant="outlined"
            className="textField"
            size="medium"
            error={status === "error"}
            helperText={
              status === "error" ? t("Please enter a valid email.") : ""
            }
          />
          <Button
            variant="contained"
            fullWidth
            onClick={handleSubmit}
            className="buttonSubmit"
          >
            {t("Submit")}
          </Button>
        </div>
      </Modal>

      {createPortal(
        <Snackbar
          key="success-snackbar"
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{
            width: "auto",
          }}
        >
          <Alert
            sx={{
              borderRadius: 8,
            }}
            elevation={6}
            variant="filled"
            severity="success"
          >
            {t("A reset link has been sent to your email!")}
          </Alert>
        </Snackbar>,
        document.body
      )}

      {createPortal(
        <Snackbar
          key="error-snackbar"
          open={openErrorSnackbar}
          autoHideDuration={3000}
          onClose={() => setOpenErrorSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{
            width: "auto",
          }}
        >
          <Alert
            sx={{
              borderRadius: 8,
            }}
            elevation={6}
            variant="filled"
            severity="error"
          >
            {t("There was an error sending the email. Please try again.")}
          </Alert>
        </Snackbar>,
        document.body
      )}
    </>
  );
};

export default ForgotPasswordModal;
